import type { IconProps } from '@src/components/icons/IconProps';

/** Paper plane, same path as santa-frontend IconSocialTg. */
export function TelegramIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="m19.617 19.913 3.32-15.27c.294-1.338-.497-1.872-1.403-1.553l-19.51 7.34C.687 10.94.712 11.666 1.797 12l4.994 1.52 11.587-7.118c.538-.35 1.036-.151.628.199l-9.376 8.265-.359 5.024c.523 0 .751-.223 1.02-.486l2.44-2.293 5.059 3.639c.922.51 1.583.246 1.828-.837Z" />
    </svg>
  );
}
